// extracted by mini-css-extract-plugin
export var bodyFont = "index-module--body-font--f4bdd";
export var inner = "index-module--inner--d922d";
export var list = "index-module--list--e4c64";
export var position_fix = "index-module--position_fix--eb3b9";
export var results_list = "index-module--results_list--d9704";
export var results_wrapper = "index-module--results_wrapper--edfa7";
export var step_wrapper = "index-module--step_wrapper--01499";
export var titleFont = "index-module--title-font--aca8c";